export const version = "providers/5.5.3";
//# sourceMappingURL=_version.js.map